import React, { useEffect, useState, useRef } from 'react';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import Home from './components/Home/Home';
import Footer from './components/Footer/Footer';
import Wallet from './components/Home/Wallet';
import Withdraw from './components/Withdraw/Withdraw';
import Transfer from './components/Transfer/Transfer';

import Deposit from './components/Deposit/Deposit';
import Records from './components/Records/Records';
import IDOHome from './components/IDO/IDOHome';
import IDOInvite from './components/IDO/IDOInvite'
import Pool from './components/Pool/Pool'

import Swap from './components/Swap/Swap';
import SwapRecord from './components/Swap/components/SwapRecords'

import DApp from './components/DApp/DApp'
import Node from './components/DApp/Node'
import Rank from './components/DApp/Rank'

import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { onBoard } from "./utils/Sign";
import { isValidAddress } from "ethereumjs-util";
import { authActions } from "./redux/actions";
import i18n from './i18n';
import useWindowDimensions from "./utils/WindowDimensions";
import ReleaseBar from "./components/ReleaseBar/ReleaseBar";
import SliderModal from './components/Note/SliderModal'
import {isValidBtcAddress, isValidDogeAddress} from "./utils/Common";
import { unlockNew, LogOut } from './utils/Sign'
import { wallets } from './constant';
import { useWalletStore } from './store/useStore'
import { Toaster } from './utils/Toaster';

function App({ t, props }) {

    const { registered, loggedIn, loggingIn, loading, l1DappSigning, checked } = useSelector(state => state.auth)
    const { message } = useSelector(state => state.wallet)
    const dispatch = useDispatch();


    const { address, setAddress, chainId, setChainId, network, setNetwork, pubKey, setPublicKey,
        walletDisconnected, setWalletDisconnected, dappConnected, setDappConnected, autoSign, setAutoSign,
        currentWallet, setWallet, startWatch, setStartWatch, button1, button2, setButton1, setButton2, setButton1Disabled, setButton2Disabled,
        button1Disabled, button2Disabled
    } = useWalletStore()

    const [navBarHeight, setNavBarHeight] = useState(0)
    const [code, setCode] = useState('')

    const [openSliderModal, setOpenSliderModal] = useState(false)
    const [sliderInfo, setSliderInfo] = useState({})
    const [signUpPayload, setSignUpPayload] = useState({})

    const [walletModalOpen, setWalletModalOpen] = useState(false)

    const { height, width } = useWindowDimensions();



    const prevDappConnected = useRef(dappConnected);
    const prevWalletDisconnected = useRef(walletDisconnected);
    const prevAddress = useRef(address);
    const prevRegistered = useRef(registered)
  
    const handleCloseSliderModal = () => {
        setOpenSliderModal(false)
    }

    const sendBackHeight = (height) => {
        setNavBarHeight(height)
    }

    const withLoggedInState = Component => {
        return function NewComponent({ isLoggedIn, ...props }) {
            return (
                <div>
                    {!isLoggedIn && <Redirect to='/' />}
                    <Component {...props} />
                </div>
            )
        }
    }

    const updateButtons = () => {
        const accountButtonsDisabled = window.ethereum === undefined
        if (accountButtonsDisabled) {
            setButton2Disabled(true)
        } else {
            setButton2Disabled(false)
        }
        if (window.ethereum === undefined && window.unisat === undefined) {
            setButton1(t('noWallet'))
            setButton1Disabled(false)
        } else if (isValidAddress(address) || isValidBtcAddress(address) || isValidDogeAddress(address)) {
            setButton1(t('connected'))
            setButton1Disabled(true)
            if (onBoard) {
                onBoard.stopOnboarding()
            }
        } else {
            setButton1(t('connect'))
            setButton1Disabled(false)
        }
    }

    const dispatchOnSlide = (payload, sliderInfo) => {
        payload.verifyData = sliderInfo
        dispatch(authActions.signUp(payload))
    }

    const checkWCConnection = (
        addr,
        chain,
        net,
        sub,
        _isConnected,
        _wallets,
        _currentWallet
      ) => {
        // console.log(
        //   'checking wallet connection: ',
        //   addr,
        //   chain,
        //   net,
        //   _isConnected,
        //   _currentWallet
        // );
        if (_currentWallet !== null) {
          if (isValidAddress(addr)) {
            setAddress(addr);
            setChainId(chain);
            setNetwork(net);
            setDappConnected(_isConnected);
            let payload = {
                address:addr, 
                chain: chain,
                network: net, 
                wallet: _currentWallet, 
                pbulicKey: addr
            }
            dispatch(authActions.saveWalletConfig(payload))
          }
    
        //   if (isValidAddress(addr) || isValidBtcAddress(addr)) {
        //     if (prevAddress.current !== addr) {
        //       // console.log('===================== monitoring new acct L1 capitals');
        //       cleanupBlockMonitor();
        //       monitorBlock();
        //     }
        //     getL1Capitals();
        //   } 
        } else {
          console.log('wrong wallet logging out !');
          setDappConnected(false);
        //   cleanupBlockMonitor();
          LogOut(dispatch, address, chainId, network, setAddress, setChainId, setNetwork, setPublicKey, setDappConnected, setWallet, setStartWatch, setWalletDisconnected)
        }
      };

      const acctsChange = (addr) => {
        setAddress(addr)
        dispatch(authActions.logOut())
      }

      const initWatchBtcWallet = async (wallet) => {
        console.log('monitor inited: !', wallet)
        if (wallet !== null && wallet.name === 'Unisat') {
          if (typeof window.unisat !== 'undefined') {
            try {
              window.unisat.on('networkChanged', (net) => {
                console.log('network change detected !: ', net)
                setNetwork(net)
                LogOut(dispatch, address, chainId, network, setAddress, setChainId, setNetwork, setPublicKey, setDappConnected, setWallet, setStartWatch, setWalletDisconnected);
              });
              window.unisat.on('accountsChanged', (addr) => {
                console.log('acct change detected !: ', addr)
                let publicKey = window.unisat.getPublicKey()
                setPublicKey(publicKey);    
                acctsChange(addr[0]);
              });
              setStartWatch(true);
            } catch (err) {
              console.log('Unisat watching changes failed: ', err);
            }
          }
        }
        if (wallet !== null && wallet.name === 'OKX Wallet') {
          if (typeof window.okxwallet !== 'undefined') {
            try {
              window.okxwallet.bitcoin.on('networkChanged', (net) => {
                console.log('network change detected !: ', net)
                setNetwork(net)
                LogOut(dispatch, address, chainId, network, setAddress, setChainId, setNetwork, setPublicKey, setDappConnected, setWallet, setStartWatch, setWalletDisconnected);              });
              window.okxwallet.bitcoin.on('accountsChanged', (addr) => {
                console.log('acct change detected !: ', addr)
                let publicKey = window.okxwallet.bitcoin.getPublicKey()
                setPublicKey(publicKey);    
                acctsChange(addr[0]);
              });
              setStartWatch(true);
            } catch (err) {
              console.log('Unisat watching changes failed: ', err);
            }
          }
        }
      }
      const removeWatchBtc = async (wallet) => {
        if (wallet.name === 'Unisat') {
          if (typeof window.unisat !== 'undefined') {
            if (startWatch) {
              try {
                window.unisat.removeListener('accountsChanged');
                window.unisat.removeListener('networkChanged');
                setStartWatch(false);
            } catch (err) {
                console.log('Unisat stop watching changes failed: ', err);
              }
            }
            
          }
        }
      }

    const initWatchDogeWallet = async (wallet) => {
        console.log('watching unielon wallet')
        if (wallet !== null && wallet.name === 'Unielon Wallet') {
            if (typeof window.unielon !== 'undefined') {
                try {
                window.unielon.on('networkChanged', (net) => {
                    console.log('network change detected !: ', net)
                    setNetwork(net)
                    LogOut(dispatch, address, chainId, network, setAddress, setChainId, setNetwork, setPublicKey, setDappConnected, setWallet, setStartWatch, setWalletDisconnected);
                });
                window.unielon.on('accountsChanged', (addr) => {
                    console.log('acct change detected !: ', addr)
                    let publicKey = window.unielon.getPublicKey()
                    setPublicKey(publicKey);    
                    acctsChange(addr[0]);
                });
                setStartWatch(true);
                } catch (err) {
                console.log('Unielon watching changes failed: ', err);
                }
            }
        }
    }

    const removeWatchDoge = async (wallet) => {
        console.log('removing unielon watch: ', wallet)
        if (wallet.name === 'Unielon Wallet') {
            if (typeof window.unielon !== 'undefined') {
                if (startWatch) {
                    try {
                        window.unielon.removeListener('accountsChanged');
                        window.unielon.removeListener('networkChanged');
                        setStartWatch(false);
                    } catch (err) {
                        console.log('Unielon stop watching changes failed: ', err);
                    }
                }
            
            }
        }
    }

    const openWalletModal = () => {
        setWalletModalOpen(true)
    }

    const closeWalletModal = () => {
        setWalletModalOpen(false)
    }

    /** check user registration on wallet connected */
    useEffect(() => {
        if (
          dappConnected ||
          (prevDappConnected.current !== dappConnected && dappConnected === true) ||
          (prevAddress.current !== address &&
            (isValidAddress(address) || isValidBtcAddress(address) || isValidDogeAddress(address)))
        ) {
          console.log('new user detected !!! checking user: ', prevAddress.current, address);
          dispatch(authActions.checkUser(address))
          closeWalletModal();

        
        console.log('============ trigger auto sign: ', !l1DappSigning && !loggedIn && (isValidBtcAddress(address) || isValidDogeAddress(address)) && autoSign)
        if (!l1DappSigning && !loggedIn && (isValidBtcAddress(address) || isValidDogeAddress(address)) && autoSign & checked) {
            dispatch(authActions.authSigning())
            unlockNew(
                address,
                chainId,
                network,
                registered,            
                currentWallet,
                dispatch,
                setAddress, setChainId, setNetwork, setWallet, setDappConnected, setPublicKey, setStartWatch, setAutoSign, setWalletDisconnected
            )
        } 



        }
        prevDappConnected.current = dappConnected;
        prevAddress.current = address;
        prevRegistered.current = registered;
    
        return () => {};
      }, [dappConnected, address, prevDappConnected, registered, prevRegistered, loggedIn, checked, l1DappSigning]);

    /** monitor acct and network changes */
    useEffect(() => {
        if (isValidBtcAddress(address)) {
            if (!startWatch) {
                initWatchBtcWallet(currentWallet)
            }
        }
        if (isValidDogeAddress(address)) {
            if (!startWatch) {
                initWatchDogeWallet(currentWallet)
            }
        }
        return() => {
            if (isValidBtcAddress(address)) {
                if (startWatch) {
                removeWatchBtc(currentWallet)
                }
            }
            if (isValidDogeAddress(address)) {
                if (startWatch) {
                removeWatchDoge(currentWallet)
                }
            }
        }
    }, [address, startWatch, currentWallet])

    useEffect(() => {
        let reg = new RegExp("(^|&)" + "ref" + "=([^&]*)(&|$)", "i");
        let r = window.location.search.substr(1).match(reg);
        let context = "";
        if (r != null)
            context = r[2];
        context = (context === null || context === "" || context === "undefined") ? "" : context;
        setCode(context)

        /** Check wallet connect flag */

         /** Grab localstorage  */
        // setLoadingData(true)
        let dis = localStorage.getItem('walletDisconnected');
        if (dis !== null) {
            dis = JSON.parse(dis)
        }
        if (walletDisconnected === null) {
            setWalletDisconnected(!!dis)
        }
        return () => {
        }
    }, [])

    useEffect(() => {
        if (loggingIn) {
            setButton2(t('loggingIn'))
        } if (!registered) {
            setButton2(t('registered'))
        } if (registered && !loggedIn) {
            setButton2(t('unlock'))
        } if (registered && loggedIn) {
            setSliderInfo({})
            setSignUpPayload({})
            setButton2(t('loggedIn'))
            setButton2Disabled(true)
        }
        updateButtons()
        return () => {
        }
    }, [i18n.language, registered, loggedIn, loggingIn, loading])

    useEffect(() => {
        updateButtons()
        return () => {
        }
    }, [button1Disabled, button2Disabled, button1, address])

    useEffect(() => {
        if (sliderInfo.token !== undefined && !openSliderModal && signUpPayload.personalSign !== undefined) {
            dispatchOnSlide(signUpPayload, sliderInfo)
        }
    }, [sliderInfo, openSliderModal, signUpPayload])


    /** trigger auto sign on wallet connected */
    useEffect(() => {
        // console.log('============ trigger auto sign: ', !l1DappSigning && !loggedIn && isValidBtcAddress(address) && autoSign)
        // if (!l1DappSigning && !loggedIn && isValidBtcAddress(address) && autoSign & checked) {
        //   dispatch(authActions.authSigning())
        //   unlockNew(
        //     address,
        //     chainId,
        //     network,
        //     registered,            
        //     currentWallet,
        //     dispatch,
        //     setAddress, setChainId, setNetwork, setWallet, setDappConnected, setPublicKey, setStartWatch, setAutoSign, setWalletDisconnected
        // )
        // } 
        // else {
        //   console.log('============ trigger auto sign: ', !walletSigning)
        // }
      }, [registered, loggedIn, l1DappSigning, autoSign, checked])


    /** WC Instance Update Check **/
    useEffect(() => {
        let monitorSubscription;
        if (
        typeof address === 'string' &&
        typeof chainId === 'number' &&
        typeof network === 'string'
        ) {
            if (isValidBtcAddress(address) || isValidDogeAddress(address)) {
                /** BTC wallet connection detected */
                if (currentWallet !== null) {
                localStorage.setItem('walletDisconnected', false.toString());
                setWalletDisconnected(false);    
                }
                if ((isValidBtcAddress(prevAddress.current) || isValidDogeAddress(prevAddress.current)) && prevAddress.current !== address) {
                acctsChange(address);
                } else {
                    monitorSubscription = checkWCConnection(
                        address,
                        chainId,
                        network,
                        monitorSubscription,
                        true,
                        wallets,
                        currentWallet
                    );
                }
            } else {
                if (
                    currentWallet !== null &&
                    currentWallet.name === 'WalletConnect'
                    ) {
                    setDappConnected(false);
                    LogOut(dispatch, address, chainId, network, setAddress, setChainId, setNetwork, setPublicKey, setDappConnected, setWallet, setStartWatch, setWalletDisconnected)
                    }
            }
        } else {
            setDappConnected(false);
            LogOut(dispatch, address, chainId, network, setAddress, setChainId, setNetwork, setPublicKey, setDappConnected, setWallet, setStartWatch, setWalletDisconnected)
            console.log(
                'Uncaught Sit: ',
                address,
                currentWallet,
            );
        }

        prevAddress.current = address;
        return () => {
        //   cleanupBlockMonitor();
        };
    }, [
        currentWallet,
        walletDisconnected,
        address, network
    ]);

    /** Check saved session on refresh */
    useEffect(() => {
        console.log('walletDisconnected updated: ', prevWalletDisconnected.current, walletDisconnected, address)
        if (walletDisconnected === false) {
            /** Check auto connect flag */
            // if (address === '') {
                /** get evn and btc wallet unlocked time and resume the latest one */
                let btcWalletConfig = JSON.parse(localStorage.getItem('btcWalletConfig'))
                let evmWalletConfig = JSON.parse(localStorage.getItem('evmWalletConfig'))
                let dogeWalletConfig = JSON.parse(localStorage.getItem('dogeWalletConfig'))
                console.log('btc wallet connection detected!', btcWalletConfig, evmWalletConfig, dogeWalletConfig)

                let nonNull = [btcWalletConfig, evmWalletConfig, dogeWalletConfig].filter(config => config !== null)
                console.log('wallet configs', nonNull)
                if (nonNull.length > 0) {
                    let latest = nonNull.reduce((latestObj, currentObj) => {
                        // If there's no latestObj yet, take the current one
                        if (!latestObj) return currentObj;
                    
                        // Compare unlockTime of the current object with the latest one
                        return new Date(currentObj.unlockTime) > new Date(latestObj.unlockTime)
                          ? currentObj
                          : latestObj;
                      }, null);
                    
                    if (latest !== null) {
                        console.log(`Resuming: ${latest.address}`)
                        setAddress(latest.address)
                        setChainId(Number(latest.chainId))
                        setNetwork(latest.network)
                        setWallet(latest.wallet)
                        let payload = {
                            address: latest.address, 
                            chainId: latest.chainId, 
                            network: latest.network
                        }
                        dispatch(authActions.checkSession(payload));    
                    }            
                }          
        }
    },[walletDisconnected])


    useEffect(() => {
        if (message === 'Access Denied') {
            setDappConnected(false)
            LogOut(dispatch, address, chainId, network, setAddress, setChainId, setNetwork, setPublicKey, setDappConnected, setWallet, setStartWatch, setWalletDisconnected)

        }
    }, [message])


    return (
        <Router>
            <ReleaseBar />
            <Navbar sendBackHeight={sendBackHeight} walletModalOpen={walletModalOpen} openWalletModal={openWalletModal} closeWalletModal={closeWalletModal} />
            <Switch>
                <Route path='/' render={({ match: { url } }) => (
                    <>
                        <Route path={`${url}/`} exact >
                            <Route path={`${url}/`} exact>
                                <Swap setWalletModalOpen={setWalletModalOpen}/>
                            </Route>
                            {/* <Redirect to="/swap" /> */}
                            {/* <Home setButton1={setButton1} setButton1Disabled={setButton1Disabled} button1={button1} button1Disabled={button1Disabled}
                                  setButton2={setButton2} setButton2Disabled={setButton2Disabled} button2={button2} button2Disabled={button2Disabled}
                                  address={address} network={network} chainId={chainId} code={code} navBarHeight={navBarHeight} setOpenSliderModal={setOpenSliderModal} handleCloseSliderModal={handleCloseSliderModal} dispatchOnSlide={dispatchOnSlide} sliderInfo={sliderInfo} setSignUpPayload={setSignUpPayload} setSliderInfo={setSliderInfo}  /> */}    
                        </Route>

                        <Route path='/pool' >
                            <Pool navBarHeight={navBarHeight} openWalletModal={openWalletModal} />
                        </Route>
                        {/* <Route path={'/wallet'} >
                            {
                                loggedIn ?
                                    <Wallet setButton1={setButton1} setButton1Disabled={setButton1Disabled} button1={button1} button1Disabled={button1Disabled}
                                            setButton2={setButton2} setButton2Disabled={setButton2Disabled} button2={button2} button2Disabled={button2Disabled}
                                            address={address} network={network} chainId={chainId} navBarHeight={navBarHeight} setOpenSliderModal={setOpenSliderModal} handleCloseSliderModal={handleCloseSliderModal} dispatchOnSlide={dispatchOnSlide} sliderInfo={sliderInfo} setSignUpPayload={setSignUpPayload} setSliderInfo={setSliderInfo}  /> :
                                    <Home setButton1={setButton1} setButton1Disabled={setButton1Disabled} button1={button1} button1Disabled={button1Disabled}
                                          setButton2={setButton2} setButton2Disabled={setButton2Disabled} button2={button2} button2Disabled={button2Disabled}
                                          address={address} network={network} chainId={chainId} code={code} navBarHeight={navBarHeight} setOpenSliderModal={setOpenSliderModal} handleCloseSliderModal={handleCloseSliderModal} dispatchOnSlide={dispatchOnSlide} sliderInfo={sliderInfo} setSignUpPayload={setSignUpPayload} setSliderInfo={setSliderInfo}  />
                            }
                        </Route>
                        <Route path={`/withdraw`} >
                            <Withdraw setButton1={setButton1} setButton1Disabled={setButton1Disabled} button1={button1} button1Disabled={button1Disabled}
                                      setButton2={setButton2} setButton2Disabled={setButton2Disabled} button2={button2} button2Disabled={button2Disabled}
                                      address={address} network={network} chainId={chainId} navBarHeight={navBarHeight} setOpenSliderModal={setOpenSliderModal} handleCloseSliderModal={handleCloseSliderModal} dispatchOnSlide={dispatchOnSlide} sliderInfo={sliderInfo} setSignUpPayload={setSignUpPayload} setSliderInfo={setSliderInfo}  />
                        </Route>
                        <Route path={`/deposit`} >
                            <Deposit setButton1={setButton1} setButton1Disabled={setButton1Disabled} button1={button1} button1Disabled={button1Disabled}
                                     setButton2={setButton2} setButton2Disabled={setButton2Disabled} button2={button2} button2Disabled={button2Disabled}
                                     address={address} network={network} chainId={chainId} navBarHeight={navBarHeight} setOpenSliderModal={setOpenSliderModal} handleCloseSliderModal={handleCloseSliderModal} dispatchOnSlide={dispatchOnSlide} sliderInfo={sliderInfo} setSignUpPayload={setSignUpPayload} setSliderInfo={setSliderInfo}  />
                        </Route>
                        <Route path={`/transfer`} >
                            <Transfer setButton1={setButton1} setButton1Disabled={setButton1Disabled} button1={button1} button1Disabled={button1Disabled}
                                      setButton2={setButton2} setButton2Disabled={setButton2Disabled} button2={button2} button2Disabled={button2Disabled}
                                      address={address} network={network} chainId={chainId} navBarHeight={navBarHeight} setOpenSliderModal={setOpenSliderModal} handleCloseSliderModal={handleCloseSliderModal} dispatchOnSlide={dispatchOnSlide} sliderInfo={sliderInfo} setSignUpPayload={setSignUpPayload} setSliderInfo={setSliderInfo}  />
                        </Route>
                        <Route path={`/records`} >
                            <Records setButton1={setButton1} setButton1Disabled={setButton1Disabled} button1={button1} button1Disabled={button1Disabled}
                                     setButton2={setButton2} setButton2Disabled={setButton2Disabled} button2={button2} button2Disabled={button2Disabled}
                                     address={address} network={network} chainId={chainId} navBarHeight={navBarHeight} setOpenSliderModal={setOpenSliderModal} handleCloseSliderModal={handleCloseSliderModal} dispatchOnSlide={dispatchOnSlide} sliderInfo={sliderInfo} setSignUpPayload={setSignUpPayload} setSliderInfo={setSliderInfo}  />
                        </Route> */}

                        <Route path='/swap' render={({ match: { url } }) => (
                            <>
                                <Route path={`${url}/`} exact>
                                    <Swap setWalletModalOpen={setWalletModalOpen} />
                                </Route>
                                <Route path={`${url}/records`} >
                                    {!loggedIn ?
                                        <Redirect to='/swap' />
                                        : <SwapRecord />
                                    }
                                </Route>
                            </>
                        )} />

                        {/* <Route path='/ido' render={({ match: { url } }) => (
                            <>
                                <Route path={`${url}/`} exact>
                                    <IDOHome setButton1={setButton1} setButton1Disabled={setButton1Disabled} button1={button1} button1Disabled={button1Disabled}
                                             setButton2={setButton2} setButton2Disabled={setButton2Disabled} button2={button2} button2Disabled={button2Disabled}
                                             address={address} network={network} chainId={chainId} code={code} navBarHeight={navBarHeight} width={width} height={height} registered={registered} loggedIn={loggedIn}
                                             loading={loading} setOpenSliderModal={setOpenSliderModal} setSignUpPayload={setSignUpPayload}
                                    />
                                </Route>
                                <Route path={`${url}/invite`} >
                                    <IDOInvite setButton1={setButton1} setButton1Disabled={setButton1Disabled} button1={button1} button1Disabled={button1Disabled}
                                               setButton2={setButton2} setButton2Disabled={setButton2Disabled} button2={button2} button2Disabled={button2Disabled}
                                               address={address} network={network} chainId={chainId} code={code} navBarHeight={navBarHeight} setOpenSliderModal={setOpenSliderModal} handleCloseSliderModal={handleCloseSliderModal} dispatchOnSlide={dispatchOnSlide} sliderInfo={sliderInfo} setSignUpPayload={setSignUpPayload} setSliderInfo={setSliderInfo}  width={width} height={height} registered={registered} loggedIn={loggedIn}
                                               loading={loading}
                                    />
                                </Route>
                            </>
                        )} /> */}

                        {/* <Route path='/dapp' render={({ match: { url } }) => (
                            <>
                                <Route path={`${url}/`} exact>
                                    <DApp setButton1={setButton1} setButton1Disabled={setButton1Disabled} button1={button1} button1Disabled={button1Disabled}
                                             setButton2={setButton2} setButton2Disabled={setButton2Disabled} button2={button2} button2Disabled={button2Disabled}
                                             address={address} network={network} chainId={chainId} code={code} navBarHeight={navBarHeight} width={width} height={height} registered={registered} loggedIn={loggedIn}
                                             loading={loading} setOpenSliderModal={setOpenSliderModal} setSignUpPayload={setSignUpPayload}
                                    />
                                </Route>
                                <Route path={`${url}/node`} >
                                    {
                                        loggedIn ?
                                            <Node setButton1={setButton1} setButton1Disabled={setButton1Disabled} button1={button1} button1Disabled={button1Disabled}
                                                  setButton2={setButton2} setButton2Disabled={setButton2Disabled} button2={button2} button2Disabled={button2Disabled}
                                                  address={address} network={network} chainId={chainId} code={code} navBarHeight={navBarHeight} width={width} height={height} registered={registered} loggedIn={loggedIn}
                                                  loading={loading} setOpenSliderModal={setOpenSliderModal} setSignUpPayload={setSignUpPayload}
                                            /> :  <Redirect to="/dapp" />
                                    }

                                </Route>
                                <Route path={`${url}/rank`} >
                                    {
                                        loggedIn ?
                                            <Rank setButton1={setButton1} setButton1Disabled={setButton1Disabled} button1={button1} button1Disabled={button1Disabled}
                                                  setButton2={setButton2} setButton2Disabled={setButton2Disabled} button2={button2} button2Disabled={button2Disabled}
                                                  address={address} network={network} chainId={chainId} code={code} navBarHeight={navBarHeight} width={width} height={height} registered={registered} loggedIn={loggedIn}
                                                  loading={loading} setOpenSliderModal={setOpenSliderModal} setSignUpPayload={setSignUpPayload}
                                            />
                                            : <Redirect to={'/dapp'} />
                                    }
                                </Route>
                            </>
                        )} /> */}
                    </>
                )} />
           
            </Switch>
            <SliderModal t={t} width={width} height={height} openSliderModal={openSliderModal} handleCloseSliderModal={handleCloseSliderModal} dispatchOnSlide={dispatchOnSlide} sliderInfo={sliderInfo} setSignUpPayload={setSignUpPayload} setSliderInfo={setSliderInfo} />
            <Toaster position="bottom-center" />
            <Footer width={width} />
        </Router>
    )
}

export default withTranslation()(App);
